const Singleton = require('../../pattern/singleton');

/**
 * Browser
 * @class
 * @extends Singleton
 */
class Browser extends Singleton {

  /**
   * for IE9+
   * @static
   */
  static getInstance() {
    return this.__proto__.getInstance.call(this);
  }

  /**
   * @static
   * @return {object} regexp browser
   */
  static get R_BROWSER() {
    return {
      CHROME : /(chrome)[ \/]([\w.]+)/,
      WEBKIT : /(webkit)[ \/]([\w.]+)/,
      OPERA  : /(opera)(?:.*version|)[ \/]([\w.]+)/,
      MSIE   : /(msie) ([\w.]+)/,
      MOZILLA: /(mozilla)(?:.*? rv:([\w.]+)|)/,
    }
  }

  /**
   * @instance
   */
  constructor() {
    super();

    const ua = window.navigator.userAgent.toLowerCase();
    const [ {}, name, version ] =
      Browser.R_BROWSER.CHROME.exec(ua) ||
      Browser.R_BROWSER.WEBKIT.exec(ua) ||
      Browser.R_BROWSER.OPERA.exec(ua) ||
      Browser.R_BROWSER.MSIE.exec(ua) ||
      (ua.indexOf("compatible") < 0) && Browser.R_BROWSER.MOZILLA.exec(ua) ||
      [];

    if(name) {
      this[name]  = true;
      const number = parseInt(version, 10);
      if(!isNaN(number)) {
        this.versionNumber = number;
      }
    }
    if(this.chrome) {
      this.webkit = true;
    }
    else if(this.webkit) {
      this.safari = true;
    }
  }

}

/**
 * class exports
 */
module.exports = Browser;



/** WEBPACK FOOTER **
 ** ./webpack/requires/models/environ/browser.js
 **/